import { CircularProgress, FormControlLabel, Link, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import _ from 'lodash';
import { useContext, useState } from "react";
import Date from "../common/date.span";
import { DialogsContext, SessionDataContext } from '../contexts';
import { holidayApi } from "./holiday.queries";
import LoadingIndicator from "../common/loading.indicator";
import moment from "moment";

export default function HolidayList(props) {
	const useGetAll = holidayApi.useGetAll();
	let holidays = useGetAll?.data;

	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	const [hidePast, setHidePast] = useState(true);

	if (useGetAll.isPending) {
		return <LoadingIndicator />;
	}

	holidays = _.orderBy(holidays, 'startDate');
	if (hidePast) {
		console.log(holidays);
		holidays = _.filter(holidays, h => (h.endDate || h.startDate) > _.now());
	}

	return (
		<Box sx={{ p: 4 }}>
			<Stack justifyContent="end">
				<FormControlLabel control={<Switch checked={hidePast} onChange={(e) => setHidePast(e.target.checked)} />} label="Upcoming Only" />
			</Stack>

			<TableContainer component={Box}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Name</TableCell>
							<TableCell align="right">Days</TableCell>
							<TableCell align="right">Start</TableCell>
							<TableCell align="right">End</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{holidays?.length > 0 && holidays.map((holiday) => {
							let diff = '';
							if (!holiday.endDate) {
								diff = 1;
							}
							else if (holiday.startDate && holiday.endDate) {
								diff = (moment(holiday.endDate).diff(moment(holiday.startDate), 'days') + 1) || 1;
							}
							return (
								<TableRow key={holiday.id}>
									<TableCell component="th" scope="row">
										<Link onClick={() => dialogs.open('holiday', holiday)}>
											{holiday.name}
										</Link>
									</TableCell>
									<TableCell align="right">{diff}</TableCell>
									<TableCell align="right"><Date date={holiday.startDate} noTime></Date></TableCell>
									<TableCell align="right"><Date date={holiday.endDate} noTime></Date></TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Add Break</Typography>} onClick={() => dialogs.open('holiday', { name: 'Break', startDate: moment() })} />
			</SpeedDial>
		</Box >
	);
}
